"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZContainer = void 0;
const AppContext_1 = require("../../utils/AppContext");
const errors_1 = require("../../errors/errors");
const fieldVisibility_1 = require("../../utils/fieldVisibility");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const ZForm_1 = require("../ZForm/ZForm");
const react_query_1 = require("react-query");
const ZAutoComplete_1 = require("../ZAutoComplete/ZAutoComplete");
const ZLoadingMask_1 = require("../ZLoadingMask/ZLoadingMask");
const ZTooltip_1 = require("../ZTooltip/ZTooltip");
const useApplicationName_1 = require("../../utils/useApplicationName");
const react_1 = require("react");
const formValidation_1 = require("../ZForm/formValidation");
const useWhyDidYouUpdate_1 = require("../../utils/useWhyDidYouUpdate");
const react_2 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const styled_components_1 = __importDefault(require("styled-components"));
const use_reducer_with_side_effects_1 = __importStar(require("use-reducer-with-side-effects"));
const emptyString = "";
const queryConfig = {
    queries: { refetchOnWindowFocus: false, suspense: true }
};
const ZContainerGrid = styled_components_1.default.div `
   display: grid;
   grid-template-rows: auto auto;
   grid-template-columns: ${props => (props.inEditMode ? "1fr" : "1fr 25px")};
   background-color: ${props => (props.inEditMode ? "white" : "transparent")};
`;
const ZContainerBody = styled_components_1.default.div `
   grid-column: 1;
   grid-row: 2;
   margin: 0;
   background-color: transparent;
   & div {
      display: inline-grid;
      grid-auto-flow: column;
      align-items: center;
      justify-content: ${props => (props.inEditMode ? "center" : "inherit")};
   }
   display: ${props => (props.numberOfColumns ? "grid" : undefined)};
   grid-template-columns: ${props => props.numberOfColumns === "auto"
    ? "repeat(auto-fit,minmax(260px,1fr))"
    : props.numberOfColumns
        ? `repeat(${props.numberOfColumns}, auto)`
        : undefined};
   grid-auto-flow: "row";
`;
const EmptyDiv = styled_components_1.default.div `
   height: 70px;
   width: auto;
`;
const Sidebar = styled_components_1.default.div `
   grid-column: 2;
   grid-row: 2;
`;
const Controls = styled_components_1.default.div `
   display: flex;
   place-content: space-evenly;
   grid-column: 2;
   grid-row: 1;
   font-size: 22px;
`;
const ControlButton = styled_components_1.default.div `
   align-self: center;
   justify-self: end;
   margin: 5px;
   color: ${props => props.theme["app-link-color"]};
   &:hover {
      color: ${props => props.theme["hover-color"]};
      cursor: pointer;
   }
   &:active {
      color: ${props => props.theme["active-color"]};
   }
`;
const FVSLevelAutoComplete = styled_components_1.default(ZAutoComplete_1.ZAutoComplete) `
   padding-top: 0px !important;
   padding-right: 10px !important;
`;
const ZContainerComponent = react_2.default.memo((props) => {
    const { appNameAbbreviation } = useApplicationName_1.useApplicationName();
    const containerId = props.id;
    const fvsParams = react_2.default.useMemo(() => {
        return {
            app: appNameAbbreviation,
            containerId,
            settingsFromProps: props.fieldVisibilitySettings,
            fvsLevelId: props.fvsLevelId
        };
    }, [appNameAbbreviation, containerId, props]);
    const { fieldVis, fieldVisDispatch: contextFieldVisDispatch, uploadFieldVisibilitySettings } = fieldVisibility_1.useFieldVisibilitySettings(fvsParams);
    const memoedChildren = react_2.default.useMemo(() => props.children, [
        props.children
    ]);
    useWhyDidYouUpdate_1.useWhyDidYouUpdate("memoedChildren", { children: props.children });
    const filteredChildren = react_2.default.useMemo(() => {
        return fieldVisibility_1.applyFieldVisibilitySettings(memoedChildren, fieldVis, props.fvsLevelId);
    }, [fieldVis, memoedChildren, props.fvsLevelId]);
    useWhyDidYouUpdate_1.useWhyDidYouUpdate("filteredChildren", { fieldVis, memoedChildren });
    const fieldsFromChildren = react_2.default.useMemo(() => {
        let counter = 0;
        let mapChildren = (children, fvsLevelId) => react_2.default.Children.map(children || [], (child, index) => {
            const { id, Id, hidden, editable, ignoreFVS, required, sortOrder, ...otherProps } = child.props;
            counter++;
            return {
                id: counter,
                Id,
                fieldName: id || "",
                hidden,
                required,
                editable,
                ignoreFVS,
                element: react_2.default.cloneElement(child, {
                    ...otherProps
                }, child.props.children),
                sortOrder: sortOrder || index,
                fvsLevelId: fvsLevelId
            };
        });
        if (props.fvsLevelData) {
            let result = [
                ...mapChildren(fieldVisibility_1.applyFieldVisibilitySettings(memoedChildren, fieldVis))
            ];
            props.fvsLevelData.forEach(fvsLevel => {
                result.push(...mapChildren(fieldVisibility_1.applyFieldVisibilitySettings(memoedChildren, fieldVis, fvsLevel.Id), fvsLevel.Id));
            });
            return result;
        }
        else {
            return mapChildren(filteredChildren);
        }
    }, [fieldVis, filteredChildren, memoedChildren, props.fvsLevelData]);
    const getNewFVS = react_1.useCallback((fields, updateSortOrder = false) => {
        let getIndex = (fields, field) => fields
            .filter(f => !f.hidden && f.fvsLevelId === field.fvsLevelId)
            .indexOf(field);
        return {
            containerId: props.id || "",
            app: appNameAbbreviation,
            components: fields
                ? fields
                    .map((field, index) => ({
                    Id: field.Id,
                    fieldName: field.fieldName,
                    sortOrder: field.hidden
                        ? -1
                        : updateSortOrder
                            ? getIndex(fields, field)
                            : field.sortOrder || getIndex(fields, field),
                    visible: field.hidden ? false : true,
                    required: field.required === undefined
                        ? false
                        : field.required,
                    editable: field.editable === undefined
                        ? true
                        : field.editable,
                    ignoreFVS: field.ignoreFVS === undefined
                        ? false
                        : field.ignoreFVS,
                    fvsLevelId: field.fvsLevelId
                }))
                    .filter(f => !!f.fieldName)
                : []
        };
    }, [appNameAbbreviation, props.id]);
    const { clearState } = props;
    const reducer = (state, action) => {
        if (action.type === "setFields") {
            if (!action.payload) {
                return use_reducer_with_side_effects_1.NoUpdate();
            }
            const newFields = action.payload && action.payload.fields;
            if (lodash_1.default.isEqual(state.fields, newFields)) {
                return use_reducer_with_side_effects_1.Update(state);
            }
            const newState = {
                ...state,
                fields: newFields
            };
            return use_reducer_with_side_effects_1.Update(newState);
        }
        if (action.type === "confirmEditing") {
            const sideEffect = (newState) => {
                const next = getNewFVS(newState.fields, true);
                contextFieldVisDispatch &&
                    contextFieldVisDispatch({
                        type: "update",
                        payload: next
                    });
                uploadFieldVisibilitySettings(next);
            };
            const newState = {
                ...state,
                fields: action.payload.newFields,
                inEditMode: false,
                previousState: null
            };
            return use_reducer_with_side_effects_1.UpdateWithSideEffect(newState, sideEffect);
        }
        if (action.type === "startEditing") {
            clearState && clearState();
            const newState = {
                ...state,
                inEditMode: true,
                previousState: state
            };
            return use_reducer_with_side_effects_1.Update(newState);
        }
        if (action.type === "cancelEditing") {
            const newState = {
                ...state.previousState,
                fields: state.previousState
                    ? state.previousState.fields
                    : state.fields,
                inEditMode: false,
                previousState: null,
                updating: false
            };
            return use_reducer_with_side_effects_1.Update(newState);
        }
        return use_reducer_with_side_effects_1.Update(state);
    };
    const [state, dispatch] = use_reducer_with_side_effects_1.default(reducer, {
        previousState: null,
        inEditMode: false,
        updating: false,
        fields: fieldsFromChildren
    });
    const newFvs = react_2.default.useMemo(() => {
        return getNewFVS(state.fields);
    }, [state.fields, getNewFVS]);
    const memoizedFields = react_2.default.useMemo(() => fieldsFromChildren.slice(), [
        fieldsFromChildren
    ]);
    const toggleEditMode = react_1.useCallback((event, newFields) => {
        if (state.inEditMode) {
            dispatch({
                type: "setFields",
                payload: { fields: newFields }
            });
            dispatch({
                type: "confirmEditing",
                payload: {
                    previousFields: state.previousState
                        ? state.previousState.fields
                        : [],
                    newFields
                }
            });
            contextFieldVisDispatch &&
                contextFieldVisDispatch({
                    type: "update",
                    payload: { ...newFvs }
                });
        }
        else {
            dispatch({
                type: "setFields",
                payload: { fields: memoizedFields }
            });
            dispatch({ type: "startEditing" });
        }
    }, [
        state.inEditMode,
        state.previousState,
        dispatch,
        contextFieldVisDispatch,
        newFvs,
        memoizedFields
    ]);
    const controls = react_2.default.useMemo(() => props.editable == false || !props.id ? null : (react_2.default.createElement(Controls, null, state.inEditMode === false ? (react_2.default.createElement(ZTooltip_1.ZTooltip, { title: "EditFieldVisibility" },
        react_2.default.createElement(ControlButton, { onClick: toggleEditMode },
            react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "edit" })))) : null)), [props.editable, props.id, state.inEditMode, toggleEditMode]);
    useWhyDidYouUpdate_1.useWhyDidYouUpdate("ZContainer", props);
    const containerRef = react_2.default.useRef(null);
    const HiddenFieldComponent = () => null;
    const { isMobile } = react_2.default.useContext(AppContext_1.AppContext);
    const formContext = react_2.default.useContext(ZForm_1.FormContext);
    const { onFormSubmit, formState } = formContext;
    const isForm = !formContext.submit ? false : true;
    const { formDispatch } = formValidation_1.useForm({
        fields: filteredChildren,
        onFormSubmit
    });
    const { setFormDispatch } = react_2.default.useContext(ZForm_1.FormDispatchContext);
    react_2.default.useEffect(() => {
        // This is necessary to load the initial values into the form state when the form is loaded
        if (formDispatch) {
            if (setFormDispatch) {
                setFormDispatch(() => formDispatch);
            }
            formDispatch({
                type: "update",
                payload: {}
            });
        }
    }, [formDispatch, setFormDispatch]);
    const container = react_2.default.useMemo(() => (react_2.default.createElement(react_query_1.ReactQueryConfigProvider, { config: queryConfig },
        react_2.default.createElement("div", { className: [props.className, "z-container"].join(" ").trim(), id: props.id
                ? `${props.id + (props.index ? "-" + props.index : "")}`
                : undefined, style: {
                zIndex: state.inEditMode ? 10004 : "auto",
                opacity: "100%"
            }, ref: containerRef },
            react_2.default.createElement(react_2.default.Suspense, { fallback: react_2.default.createElement(ZLoadingMask_1.ZLoadingMask, { containerSelector: `#${props.id}` }) },
                react_2.default.createElement(ZContainerGrid, { inEditMode: state.inEditMode },
                    react_2.default.createElement(ZContainerBody, { className: "z-container-body", inEditMode: state.inEditMode, numberOfColumns: props.numberOfColumns, style: { ...props.inlineStyle } },
                        react_2.default.createElement(react_2.default.Suspense, { fallback: react_2.default.createElement(ZLoadingMask_1.ZLoadingMask, { containerSelector: `#${props.id}` }) }, filteredChildren &&
                            react_2.default.Children.map(filteredChildren, child => {
                                const fieldKey = child.props.id || child.props.label;
                                return child.props.hidden ? (react_2.default.createElement(HiddenFieldComponent, Object.assign({}, child.props))) : !isForm ? (child) : (react_2.default.cloneElement(child, {
                                    ...child.props,
                                    onChange: (...args) => {
                                        formDispatch({
                                            type: "update",
                                            payload: {
                                                field: fieldKey,
                                                value: args[0]
                                                    ? args[0].target.type ===
                                                        "checkbox"
                                                        ? args[0].target
                                                            .checked
                                                        : args[0].target.value
                                                    : args[1],
                                                touch: args[2] !== false
                                            }
                                        });
                                        child.props.onChange &&
                                            child.props.onChange(...args);
                                    },
                                    required: formState &&
                                        formState.fields &&
                                        formState.fields[fieldKey]
                                        ? formState.fields[fieldKey]
                                            .required
                                        : child.props.required,
                                    valid: formState &&
                                        formState.fields &&
                                        formState.fields[fieldKey]
                                        ? formState.fields[fieldKey]
                                            .valid ||
                                            !formState.fields[fieldKey]
                                                .touched
                                        : true
                                }));
                            })
                                .filter(f => f.props.sortOrder !== -1)
                                .reduce((prev, current, index, array) => {
                                const currentSortOrder = current.props.sortOrder;
                                const previousSortOrder = prev.length
                                    ? prev[prev.length - 1].props
                                        .sortOrder
                                    : -1;
                                for (let i = previousSortOrder + 1; i < currentSortOrder; i++) {
                                    prev.push(react_2.default.createElement(EmptyDiv, null));
                                }
                                prev.push(current);
                                return prev;
                            }, []))),
                    isMobile === true ? null : (react_2.default.createElement(Sidebar, null, controls))))))), [
        controls,
        filteredChildren,
        formDispatch,
        formState,
        isForm,
        isMobile,
        props.className,
        props.id,
        props.index,
        props.inlineStyle,
        props.numberOfColumns,
        state.inEditMode
    ]);
    const cancelEditing = react_2.default.useCallback(() => dispatch({ type: "cancelEditing" }), [dispatch]);
    const onSave = react_2.default.useCallback(fields => {
        toggleEditMode(undefined, fields);
    }, [toggleEditMode]);
    return (react_2.default.createElement(react_2.default.Fragment, null, state.inEditMode ? (react_2.default.createElement(fieldVisibility_1.FieldVisibilitySettingsPopup, { allowedFieldStates: props.allowedFieldStates, containerId: containerId || emptyString, fields: memoizedFields, onSave: onSave, onCancel: cancelEditing, inlineStyle: props.inlineStyle, numberOfColumns: props.numberOfColumns, allowEmptySpace: props.allowEmptySpace, fvsLevelAutoComplete: FVSLevelAutoComplete, fvsLevelData: props.fvsLevelData, fvsLevelId: props.fvsLevelId })) : (container)));
}, (prev, next) => lodash_1.default.isEqual(prev, next));
const StyledZContainerComponent = styled_components_1.default(ZContainerComponent) `
   margin: 10px 0 0 10px;
   padding-bottom: 10px;
   position: relative;
   background: transparent;
   box-shadow: none;
   transition: none;
   & .dl-item {
      vertical-align: middle;
      & .portal-label-header {
         font-size: 16px;
         text-overflow: ellipsis;
         overflow: hidden;
         white-space: nowrap;
      }
      &:active,
      &.activity {
         cursor: grabbing !important;
      }
   }
`;
exports.ZContainer = (props) => (react_2.default.createElement(errors_1.ErrorBoundary, null,
    react_2.default.createElement(fieldVisibility_1.FieldVisibilityProvider, null,
        react_2.default.createElement(StyledZContainerComponent, Object.assign({}, props)))));
//# sourceMappingURL=ZContainer.js.map